import React, { memo } from 'react'
import styles from './RecommendationParameterOverview.module.scss'
import PreviewSectionItem from '../../../../common/components/preview-section-item/PreviewSectionItem'
import { useNavigate } from 'react-router-dom'
import { ApplicationRoutes } from '../../../../routes'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../stores/store'
import { averagePower, countOfAppliances, totalPower, totalWatts } from '../../../../stores/slices/solar-recommendation-slice'

type Props = {}

const RecommendationParameterOverview: React.FC<Props> = memo((props: Props) => {
    const form = useSelector((state: RootState) => state.solarRecommendation.form);
    const totalWattsInHouse = useSelector(totalWatts);
    const totalDailyUsage = useSelector(totalPower);
    const averageDailyUsage = useSelector(averagePower);
    const count = useSelector(countOfAppliances);

    const navigate = useNavigate();

    const returnToEditing = () => {
        navigate(`/${ApplicationRoutes.RECOMMENDATION}`);
    }

    return (
        <div className={styles.container}>
            <button className={`standardButton ${styles.editAppliancesButton}`} onClick={returnToEditing}>
                Edit your appliances
            </button>
            <div className={styles.segmentHeader}>
                YOUR ENERGY NEEDS SUMMARY
            </div>
            <PreviewSectionItem items={
                [
                    {
                        data: [`${count} Appliances`],
                        label: 'Total appliance added'
                    },
                    {
                        data: [`${totalWattsInHouse.toLocaleString()} watts`],
                        label: 'Total watts added'
                    },
                    {
                        data: [`${totalDailyUsage.toLocaleString()} watts`],
                        label: 'Total daily usage'
                    },
                    {
                        data: [`${averageDailyUsage.toLocaleString()} watts`],
                        label: 'Average daily usage'
                    }
                ]
            } />
            <div className={styles.segmentHeader}>
                APPLIANCES
            </div>
            <PreviewSectionItem items={
                form.appliances.map(applianceItem => {
                    return {
                        data: [
                            `Qty: ${applianceItem.quantity}`,
                            `Daily usage: ${applianceItem.dailyUsage} hrs`,
                        ],
                        label: applianceItem.appliance.name
                    }
                })
            } />
            <div className={styles.segmentHeader}>
                PAYMENT PLAN
            </div>
            <PreviewSectionItem items={
                [
                    {
                        data: [Number.parseFloat(form.paymentPlan?.alternatePowerExpense.toString() ?? '').toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'NGN'
                        })],
                        label: 'Alternate Power Expense'
                    },
                    {
                        data: [Number.parseFloat(form.paymentPlan?.solarMonthlyRepayment.toString() ?? '').toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'NGN'
                        })],
                        label: 'Solar Monthly Repayment'
                    },
                    {
                        data: [`${form.paymentPlan?.paymentPlan} months`],
                        label: 'Payment Plan'
                    }
                ]
            } />
        </div>
    )
})

export default RecommendationParameterOverview